import { UserPermission } from "../user-permissions";

type PermissionType = "CAMPAIGN" | "ORGANISATION";
export interface PermissionLevel {
    readonly permissionid: number;
    permissionname: string;
    readonly internalName: string;
    permissionexplanation: string;
    readonly permissiontype: PermissionType;
    readonly featureKey?: string;
}

export const permissionLevelsConstants: {
    readonly levels: readonly PermissionLevel[];
} = {
    levels: [
        {
            permissionid: 8,
            permissionname: "Organization Owner",
            internalName: "Organization Owner",
            permissionexplanation:
                "Access to all features of the dashboard. Whoever creates the organisation initially is the Organization Owner.",
            permissiontype: "ORGANISATION",
            featureKey: "organisationowner",
        },
        {
            permissionid: 9,
            permissionname: "Organization Manager",
            internalName: "Organization Manager",
            permissionexplanation:
                "Access to all content and features within the organization dashboard.",
            permissiontype: "ORGANISATION",
            featureKey: "organisationleader",
        },
        {
            permissionid: 10,
            permissionname: "Division Manager",
            internalName: "Division Manager",
            permissionexplanation:
                "Access to all content and features within the specified division and its sub accounts. Restricted from creating sub accounts and inviting members as organization managers.",
            permissiontype: "ORGANISATION",
            featureKey: "divisionmanager",
        },
        {
            permissionid: 2,
            permissionname: "Account Owner",
            internalName: "Account Owner",
            permissionexplanation:
                "Access to all features of the dashboard. Whoever creates the account initially is the Account Owner.",
            permissiontype: "CAMPAIGN",
            featureKey: "owner",
        },
        {
            permissionid: 3,
            permissionname: "Account Manager",
            internalName: "Account Manager",
            permissionexplanation:
                "Access to all features within the dashboard and mobile apps except for billing administration. Note: Account Owner may grant access to the billing administration to any Account Manager.\n",
            permissiontype: "CAMPAIGN",
            featureKey: "campaignmanager",
        },
        {
            permissionid: 4,
            permissionname: "Staffer",
            internalName: "Staffer",
            permissionexplanation:
                "Access to most features within the dashboard and mobile apps. \n" +
                "This permission level is restricted from creating lists, and does not have access to the Analytics page.",
            permissiontype: "CAMPAIGN",
            featureKey: "campaignstaffer",
        },
        {
            permissionid: 5,
            permissionname: "Lead Organizer",
            internalName: "Lead Organizer",
            permissionexplanation:
                "Restricted access to mobile apps and dashboard. Unlimited access to all contacts in the dashboard. Unlimited access to past interaction activity.",
            permissiontype: "CAMPAIGN",
            featureKey: "leadcanvasser",
        },
        {
            permissionid: 6,
            permissionname: "Organizer",
            internalName: "Organizer",
            permissionexplanation:
                "Restricted access to mobile apps and dashboard. Limit access to historical interaction activity.",
            permissiontype: "CAMPAIGN",
            featureKey: "canvasser",
        },
        {
            permissionid: 7,
            permissionname: "Revoked",
            internalName: "Revoked",
            permissionexplanation:
                "This user has been removed from the account and will need to be re-invited to the account to able to canvass;",
            permissiontype: "CAMPAIGN",
            featureKey: null,
        },
    ],
} as const;

export const superUserPermissionIdsConstants = [
    UserPermission.ACCOUNT_OWNER,
    UserPermission.ACCOUNT_MANAGER,
    UserPermission.STAFFER,
    UserPermission.LEADER_OWNER,
    UserPermission.LEADER_MANAGER,
    UserPermission.DIVISION_MANAGER,
];

export const standardUserPermissionIdsConstants = [
    UserPermission.LEAD_CANVASSER,
    UserPermission.CANVASSER,
];
